<app-dialog-header
  [title]="'scheduler.setup.zone.postcode-lookup.title' | translate"
  (closeClicked)="onClose()"
>
</app-dialog-header>

<div mat-dialog-content>
  <p>{{ "scheduler.setup.zone.postcode-lookup.instructions" | translate }}</p>

  <div class="lookup-form">
    <mat-form-field class="full-width">
      <mat-label>{{
        "scheduler.setup.zone.postcode-lookup.label" | translate
      }}</mat-label>
      <input
        matInput
        [formControl]="postcodeControl"
        (keyup.enter)="lookup()"
        autocomplete="off"
        autocapitalize="characters"
        autocorrect="off"
        data-lpignore="true"
        spellcheck="false"
      />
    </mat-form-field>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="lookup()"
      [disabled]="searching || !postcodeControl.value?.trim()"
    >
      {{ "scheduler.setup.zone.postcode-lookup.check" | translate }}
    </button>
  </div>

  @if (searching) {
    <div class="lookup-loading">
      <mat-progress-spinner
        color="primary"
        mode="indeterminate"
        diameter="24"
      ></mat-progress-spinner>
    </div>
  }

  @if (!searching && error) {
    <div class="lookup-status lookup-status--error">
      <mat-icon fontIcon="fa-circle-exclamation" fontSet="fas"></mat-icon>
      <span>{{
        "scheduler.setup.zone.postcode-lookup.lookup-error" | translate
      }}</span>
    </div>
  }

  @if (!searching && !error && result) {
    @if (!result.found) {
      <div class="lookup-status lookup-status--error">
        <mat-icon fontIcon="fa-circle-exclamation" fontSet="fas"></mat-icon>
        <span>{{
          "scheduler.setup.zone.postcode-lookup.not-found"
            | translate: { postcode: result.postcode }
        }}</span>
      </div>
    } @else {
      <div class="lookup-location">
        <span>
          {{ "scheduler.setup.zone.postcode-lookup.location" | translate }}:
          {{ result.latitude }} / {{ result.longitude }}
        </span>
        <button
          type="button"
          mat-stroked-button
          color="primary"
          (click)="showOnMap()"
        >
          <mat-icon fontIcon="fa-map-location-dot" fontSet="fas"></mat-icon>
          {{ "scheduler.setup.zone.postcode-lookup.show-on-map" | translate }}
        </button>
      </div>

      @if (result.zones.length === 0) {
        <div class="lookup-status lookup-status--warn">
          <mat-icon fontIcon="fa-triangle-exclamation" fontSet="fas"></mat-icon>
          <span>{{
            "scheduler.setup.zone.postcode-lookup.no-zones" | translate
          }}</span>
        </div>
      } @else {
        <p class="lookup-assigned-note">
          {{ "scheduler.setup.zone.postcode-lookup.assigned-note" | translate }}
        </p>
        <table class="lookup-table">
          <thead>
            <tr>
              <th>
                {{
                  "scheduler.setup.zone.postcode-lookup.col-ordinal" | translate
                }}
              </th>
              <th>
                {{
                  "scheduler.setup.zone.postcode-lookup.col-name" | translate
                }}
              </th>
              <th>
                {{ "scheduler.setup.zone.postcode-lookup.col-id" | translate }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (zone of result.zones; track zone.id; let first = $first) {
              <tr [class.assigned-row]="first">
                <td>
                  <span
                    class="zone-swatch"
                    [style.background]="zone.backgroundColor || 'transparent'"
                  ></span>
                  {{ zone.ordinal }}
                </td>
                <td>{{ zone.name }}</td>
                <td>{{ zone.id }}</td>
                <td>
                  @if (first) {
                    <span class="assigned-badge">
                      <mat-icon
                        fontIcon="fa-circle-check"
                        fontSet="fas"
                      ></mat-icon>
                      {{
                        "scheduler.setup.zone.postcode-lookup.assigned-badge"
                          | translate
                      }}
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
  }
</div>
